import type { IconData } from '@stacksjs/iconify-core'

export const ye4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M0 0h640v472.8H0z\"/><path fill=\"#f10600\" d=\"M0 0h640v157.4H0z\"/><path fill=\"#000001\" d=\"M0 322.6h640V480H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ye4x3
